import { Auth0ContextInterface } from "@auth0/auth0-react";
import ChannelDomain from "entities/domain/contacts/contact-domain";
import { ChannelsDto } from "entities/dto/ChannelsDTO";
import { adminContactChannelTransformerFromDtoToDomain } from "entities/transformers/admin-contact-channel-transformer";
import { fetchMerchant } from "redux/features/merchant";
import store from "redux/store";
import { RequestType } from "services/request-type";
import { deleteRequest, mutationRequest } from "util/methods";

export default class ChannelService {
  public static async disableWhatsappChannel(
    { getAccessTokenSilently }: Auth0ContextInterface,
    phoneNumber: string,
    merchantId: number
  ): Promise<void> {
    const accessToken = await getAccessTokenSilently();

    await deleteRequest<void>(
      RequestType.DELETE,
      accessToken,
      `/merchants/${merchantId}/360dialog/integration`,
      {
        phone_number: phoneNumber,
      }
    );

    store.dispatch(fetchMerchant());
  }

  public static async assignSmsChannel(
    { getAccessTokenSilently }: Auth0ContextInterface,
    merchantId: number
  ): Promise<ChannelDomain> {
    const accessToken = await getAccessTokenSilently();

    const response = await mutationRequest(
      RequestType.POST,
      accessToken,
      `/merchants/${merchantId}/channels/sms`
    );

    const contactChannel: ChannelsDto = response.data;
    return adminContactChannelTransformerFromDtoToDomain(contactChannel);
  }
}
